import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ParseQueryParameter,
    PopulateApiParameter
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import qs from "qs";

addToChainAfter(chain, ParseQueryParameter, props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString) as any;
    const splitCommaSeparated = (value?: string | string[] | null) =>
        value && typeof value === "string" ? value.split(",") : undefined;
    
    const {
        wishlistIds,
        categoryIds,
    } = parsedQuery;

    (props.result.productFilters as any) = {
        ...props.result.productFilters,
        categoryIds: splitCommaSeparated(categoryIds),
        wishlistIds: splitCommaSeparated(wishlistIds),
    }
});

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.expand?.push("properties");
});
